const MockData = [
  {
    sr_number: "NA10034SAV",
    sr_date: "07/07/2024",
    service_type: "Routine Maintainence",
    description:
      "The engine is experiencing reduced thrust during takeoff and intermittent vibrations at cruising altitude",
    specific_maintainence_task_requested:
      "Inspect and clean fuel injectors. Replace worn-out turbine blades. Conduct full diagnostic testing. Perform software updates on engine control systems",
    symptoms_observed:
      "Reduced thrust during takeoff. Intermittent vibrations at cruising altitude. Unusual noise from the turbine",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/07/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA10035SAV",
    sr_date: "07/06/2024",
    service_type: "Emergency Repair",
    description:
      "The cockpit display screens are flickering and occasionally going blank during flights.",
    specific_maintainence_task_requested:
      "Check electrical connections and wiring for the displays. Replace any damaged display units. Update display software. Test the stability of display systems under different flight conditions",
    symptoms_observed:
      " Flickering and intermittent blank screens. Error messages on cockpit displays. Display resets during flight",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/06/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA10038SAV",
    sr_date: "07/05/2024",
    service_type: "Routine Maintainence",
    description:
      "The cabin temperature control system is not maintaining the set temperature, leading to fluctuating cabin temperatures",
    specific_maintainence_task_requested:
      "Inspect and clean air ducts and vents. Replace faulty temperature sensors. Calibrate the temperature control system. Test the temperature regulation under different conditions",
    symptoms_observed:
      "Fluctuating cabin temperatures. Inconsistent cooling/heating in different cabin zones. Passenger complaints about temperature variations",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/05/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA10041SAV",
    sr_date: "07/04/2024",
    service_type: "Routine Maintainence",
    description:
      "Unusual noise is coming from the right wing during flight, particularly during turbulence.",
    specific_maintainence_task_requested:
      "Inspect the right wing structure for any loose components. Tighten or replace loose fittings. Conduct a thorough check for structural integrity. Perform vibration analysis to identify the source of noise",
    symptoms_observed:
      "Unusual rattling noise from the right wing. Increased noise during turbulence. No visible damage on the wing surface",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/04/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA11041SAV",
    sr_date: "07/04/2024",
    service_type: "Routine Maintainence",
    description: "The autopilot system occasionally disengages without warning",
    specific_maintainence_task_requested:
      "Perform diagnostics on the autopilot system. Check and update autopilot software. Inspect and repair any faulty sensors or connections. Conduct in-flight tests to ensure autopilot stability.",
    symptoms_observed:
      "Unexpected disengagement of autopilot. Autopilot error messages. Manual override required by pilots during disengagement",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/04/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA10044SAV",
    sr_date: "07/02/2024",
    service_type: "Routine Maintainence",
    description:
      "The aircraft's lavatory water system is not dispensing water properly.",
    specific_maintainence_task_requested:
      "Inspect and clean water lines and filters, Replace any faulty water pumps, Check for leaks in the water system, Test water flow and pressure in lavatories",
    symptoms_observed:
      "Low or no water flow in lavatory sinks. Intermittent water dispensing. Complaints from passengers about non-functional lavatories",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/02/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA10448SAV",
    sr_date: "07/02/2024",
    service_type: "Routine Maintainence",
    description:
      "The overhead compartment lights are flickering and sometimes not turning on.",
    specific_maintainence_task_requested:
      "Check and replace faulty light fixtures. Inspect electrical wiring and connections for the lighting system. Replace any damaged light switches. Test the lights for stability and proper operation",
    symptoms_observed:
      "Flickering overhead lights. Lights not turning on in some compartments. Passenger complaints about inadequate lighting",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/02/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA10548SAV",
    sr_date: "07/01/2024",
    service_type: "Emergency Repair",
    description:
      "The aircraft's de-icing system is not functioning properly, leading to ice accumulation on the wings",
    specific_maintainence_task_requested:
      "Inspect and repair de-icing boots and heating elements. Check and refill de-icing fluid reservoirs. Perform system diagnostics and calibrations. Test the de-icing system under simulated icing conditions",
    symptoms_observed:
      "Ice accumulation on wings during flight. De-icing system warning lights. Difficulty in maintaining aircraft stability in icy conditions",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "SR RAISED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/01/2024",
        status: "in-progress",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "",
        status: "pending",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "pending",
        message: "",
      },
    ],
  },
  {
    sr_number: "NA17448SAV",
    sr_date: "07/05/2024",
    service_type: "Routine Maintenance",
    description:
      "The flight attendants' intercom system is not working correctly, causing communication issues during service.",
    specific_maintainence_task_requested:
      "Inspect and repair intercom system wiring and components. Replace faulty intercom units. Test the intercom system throughout the cabin. Ensure clear and stable communication channels",
    symptoms_observed:
      " Static or no sound from intercom speakers. Intermittent communication interruptions. Complaints from flight attendants about the intercom system",
    attachments: [
      {
        type: "pdf",
        url: "",
      },
      {
        type: "word",
        url: "",
      },
      {
        type: "text",
        url: "",
      },
    ],
    priority: "Medium",
    created_by: "priyesh.vasani@affine.ai",
    status: "DISPATCHED",
    comments:
      "Technician started diagnostics. Issue with landing gear identified",
    lifecycle: [
      {
        status_name: "SR RAISED",
        status_date: "07/05/2024",
        status: "completed",
        message: "",
      },
      {
        status_name: "Approved",
        status_date: "07/06/2024",
        status: "completed",
        message: "",
      },
      {
        status_name: "Scheduled",
        status_date: "07/07/2024",
        status: "completed",
        message: "",
      },
      {
        status_name: "Review & Quality Check",
        status_date: "07/08/2024",
        status: "completed",
        message: "",
      },
      {
        status_name: "Completed",
        status_date: "07/08/2024",
        status: "completed",
        message: "",
      },
      {
        status_name: "Dispatched",
        status_date: "",
        status: "in-progress",
        message: "",
      },
    ],
  },
];

export default MockData;
